import { ReactNode } from 'react'

interface NormalLayoutProps {
  children: ReactNode
}

const NormalLayout = ({ children }: NormalLayoutProps) => {
  return (
    <div className="page-container section-padding animate-fade-in">
      {children}
    </div>
  )
}

export default NormalLayout
